export default {
  data () {
    return {
      isLowArr: [ //高低频
        { val: 999, text: '全部' },
        { val: 1, text: '低頻彩' },
        { val: 2, text: '高頻彩' },
      ],
      ismyArr: [ //彩种类型
        { val: 999, text: '全部' },
        { val: 1, text: '自开采' },
        { val: 0, text: '官彩' },
      ],
      groupArr: [ //彩种系列 api沒有catenaId
        //val9 = val1 val5 = val2 val15 = val1
        { val: 999, text: '全部' },
        { val: 1, text: '六合彩' },
        { val: 2, text: 'pk拾' },
        { val: 3, text: '时时彩' },
        { val: 4, text: '快十' },
        { val: 6, text: '11选5' },
        { val: 8, text: '快三' },
        { val: 10, text: '基诺彩' },
        { val: 11, text: '28系列' },
        { val: 12, text: '福利彩' },
        { val: 15, text: '539系列' },
        { val: 16, text: '38乐合' },
      ],
      catenaIdArr: [ //彩种系列 api有catenaId
        { val: 999, text: '全部' },
        { val: 1, text: '六合彩' },
        { val: 2, text: 'pk拾' },
        { val: 3, text: '时时彩' },
        { val: 4, text: '快十' },
        { val: 5, text: '快三' },
        { val: 6, text: '11选5' },
        { val: 7, text: '基诺彩' },
        { val: 8, text: '福利彩' },
        { val: 9, text: '28系列' },
        { val: 10, text: '体育彩' },
        { val: 11, text: '官方彩' },
        { val: 12, text: '潮汕盘口' },
      ],
      idopArr: [ //站台管理页面 启用状态
        { val: 999, text: '全部' },
        { val: 1, text: '启用' },
        { val: 0, text: '关闭' },
      ],
      siteIdArr: [ //站台管理页面 启用状态
        { val: 999, text: '全部' },
        { val: 0, text: '不限' },
        { val: 1, text: '自站' },
        { val: 2, text: '租站' },
      ],
    }
  },
}